import { Flex } from "@chakra-ui/react";
import colors from "resources/theme/colors";
import SelectableButton from "components/Button/SelectableButton";
import InputSearch from "components/Input/InputSearch";
import OpcoesSearch from "./OpcoesSearch";
import {
  RelatorioDespesaFields,
  fieldsRelatorioDespesaColumns,
} from "features/relatorios/typings";
import ModalSelectFieldsRelatorio from "ui/components/ModalSelectFieldsRelatorio/index";
import { AssinaturasItem } from "components/Relatorio/FormAssinaturas";

export interface HeaderTableProps {
  onSearch: (q?: string) => void;
  value: string;
  pago?: number;
  onSelectPago?: (v: number | undefined) => any;

  onUnselect: () => any;
  setExportType: (type: { type: "pdf" | "excel" } | undefined) => any;
  modalSelectFieldsOpen: boolean;
  setModalSelectFieldsOpen: (isOpen: boolean) => any;
  _onExportPdf: (
    selectedFields: RelatorioDespesaFields[],
    assinaturas?: AssinaturasItem[]
  ) => any;
  _onExportExcel: (selectedFields: RelatorioDespesaFields[]) => any;
  exportType: { type: "pdf" | "excel" } | undefined;
}

function HeaderTable({
  onSearch,
  value,
  pago,
  onSelectPago,

  _onExportExcel,
  _onExportPdf,
  modalSelectFieldsOpen,
  onUnselect,
  setExportType,
  setModalSelectFieldsOpen,
  exportType,
}: HeaderTableProps) {
  return (
    <>
      <Flex flexDir="column">
        <Flex gridGap="16px" flexWrap="wrap">
          <Flex w="100%" maxW="350px">
            <InputSearch defaultValue={value} onSearch={(v) => onSearch(v)} />
          </Flex>

          <Flex flex={1} gridGap={4} flexWrap="wrap">
            <Flex flex={1} pt="4px">
              <Flex gridGap="16px">
                <SelectableButton
                  selected={pago === 1}
                  onClick={() => onSelectPago?.(pago === 1 ? undefined : 1)}
                  onUnselect={onUnselect}
                  rounded="full"
                  selectedColor={colors.green500}
                  fontSize="14px"
                >
                  Pago
                </SelectableButton>
                <SelectableButton
                  selected={pago === 0}
                  onClick={() => onSelectPago?.(pago === 0 ? undefined : 0)}
                  onUnselect={onUnselect}
                  rounded="full"
                  selectedColor={colors.orange}
                  fontSize="14px"
                >
                  Em aberto
                </SelectableButton>
              </Flex>
            </Flex>
            <Flex>
              <OpcoesSearch
                onExportPdf={() => {
                  setExportType({ type: "pdf" });
                }}
                onExportarXlsx={() => {
                  setExportType({ type: "excel" });
                }}
                onImprimir={() => ""}
              />
            </Flex>
          </Flex>
        </Flex>
      </Flex>
      <ModalSelectFieldsRelatorio
        visible={modalSelectFieldsOpen}
        onClose={() => setModalSelectFieldsOpen(false)}
        onSubmit={({ fields, assinaturas }) => {
          exportType?.type === "pdf"
            ? _onExportPdf(fields, assinaturas)
            : _onExportExcel(fields);

          setModalSelectFieldsOpen(false);
        }}
        fields={
          fieldsRelatorioDespesaColumns as {
            label: string;
            value: RelatorioDespesaFields;
            defaultChecked?: boolean;
          }[]
        }
      />
    </>
  );
}

export default HeaderTable;
